import configJSON from 'config/config.json';

// const getBackendHost = () => {
// 	// eslint-disable-next-line no-undef
// 	const host = __BUILDMODE__ && __BUILDMODE__ === 'dev' && configJSON.host_dev ? configJSON.host_dev : configJSON.host;

// 	let hostUrl;
// 	try {
// 		hostUrl = new URL(host);
// 	} catch (error) {
// 		if (error.name === 'TypeError') {
// 			hostUrl = new URL(window.location.origin);
// 		} else {
// 			console.error('couldnt create host url', error);
// 		}
// 	}
// 	let urlStr = hostUrl.toString();
// 	if (urlStr.endsWith('/')) {
// 		urlStr = urlStr.slice(0, -1);
// 	}
// 	return urlStr;
// };

const getBackendHost = () => {
	// 1. First priority: runtime env injected by Docker
	const runtimeHost =
	  window?.env?.REACT_APP_BACKEND_API_BASE_URL;
  
	// 2. Fallback to existing build-time config
	// eslint-disable-next-line no-undef
	const fallbackHost =
	  __BUILDMODE__ && __BUILDMODE__ === 'dev' && configJSON.host_dev
		? configJSON.host_dev
		: configJSON.host;
  
	const host = runtimeHost || fallbackHost;
  
	let hostUrl;
	try {
	  hostUrl = new URL(host);
	} catch (error) {
	  if (error.name === 'TypeError') {
		hostUrl = new URL(window.location.origin);
	  } else {
		console.error('couldnt create host url', error);
	  }
	}
  
	let urlStr = hostUrl.toString();
	if (urlStr.endsWith('/')) {
	  urlStr = urlStr.slice(0, -1);
	}
  
	return urlStr;
  };

const getBackendUrl = () => `${getBackendHost()}/api`;

const getStaticBackendUrl = () => `${getBackendHost()}/pa`;

const getBackendWebsocketUrl = () => {
	const hostUrl = new URL(getBackendHost());
	// change protocol
	if (hostUrl.protocol === 'https:') {
		hostUrl.protocol = 'wss:';
	} else {
		hostUrl.protocol = 'ws:';
	}
	let urlStr = hostUrl.toString();
	if (urlStr.endsWith('/')) {
		urlStr = urlStr.slice(0, -1);
	}
	return urlStr;
};

export { getBackendUrl, getStaticBackendUrl, getBackendWebsocketUrl };
